import { render, staticRenderFns } from "./send-message-using-template-drawer.vue?vue&type=template&id=81ec9d88&scoped=true&"
import script from "./send-message-using-template-drawer.vue?vue&type=script&lang=ts&"
export * from "./send-message-using-template-drawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ec9d88",
  null
  
)

export default component.exports